import { toast } from "react-hot-toast";
import httpRequest from "../axios/index";
import { NOTIFICATIONS } from "../constants/apiEndPoints";

export const ReadAllNotifications = async () => {
  try {
    await httpRequest.patch(`${NOTIFICATIONS}/all`);
  } catch (error) {
    const errorMessage =
      error?.response?.data?.message || "Something went wrong";
    toast.error(errorMessage);
  }
};
